module.exports = __webpack_public_path__ + "img/bg-reservedseating.c198aa49.jpg";